/** The maximum number of schedules that can be created in Business Hours. */
export const BUSINESS_HOURS_MAX_NUMBER_SCHEDULES = 100;
